/* src/app/front-layout/question-bank/question-bank.component.css */
.q-hero {
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background-color: white;
  font-family: "Arial", sans-serif;
  background-image: url(/assets/images/quest-hs.png);
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  place-items: center;
}
.q-hero h1 {
  margin-top: 50px;
  font-size: 64px;
  font-weight: 550;
  color: white;
}
.q-hero button {
  width: 200px;
  background-color: #0077b6;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 550;
  margin: 20px;
}
.question-bank {
  margin-top: 10px;
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: #e6f1f9;
}
.question-bank h2 {
  width: 40%;
  font-size: 36px;
  font-weight: 550;
  margin: 50px;
  text-align: center;
}
.qb-cards {
  width: 60%;
  display: flex;
  align-items: center;
  padding: 5px;
  gap: 25px;
}
.qb-card {
  width: 280px;
  height: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  align-items: center;
  border-radius: 20px;
  background-color: white;
  box-shadow: 0 2px 16px rgba(92, 92, 92, 0.08);
}
.qb-card img {
  width: 200px;
  height: 180px;
  object-fit: cover;
}
.qbc-head {
  font-size: 24px;
  font-weight: 600;
}
.qbc-des {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4em;
  max-height: calc(1.4em * 2);
  font-size: 16px;
  font-weight: 400;
  margin: 10px;
  text-align: center;
}
.view-btn {
  margin-top: 20px;
  width: 150px;
  padding: 5px;
  border: none;
  border-radius: 30px;
  color: white;
  font-weight: 600;
  text-align: center;
  background-color: #0077b6;
}
.m {
  border: solid;
  border-color: #715edb;
}
.a {
  border: solid;
  border-color: #0077b6;
}
@media screen and (max-width: 1024px) {
  .q-hero {
    height: 40vh;
  }
  .q-hero h1 {
    font-size: 48px;
  }
  .question-bank {
    flex-direction: column;
    padding: 15px;
  }
  .question-bank h2 {
    width: 100%;
    font-size: 28px;
    margin: 20px 0;
  }
  .qb-cards {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
  }
  .qb-card {
    width: 240px;
    height: 340px;
  }
  .qb-card img {
    width: 180px;
    height: 160px;
  }
}
@media screen and (max-width: 768px) {
  .q-hero {
    height: 35vh;
    background-attachment: scroll;
  }
  .q-hero h1 {
    font-size: 36px;
    margin-top: 30px;
  }
  .q-hero button {
    width: 180px;
    padding: 8px 16px;
    font-size: 16px;
  }
  .question-bank {
    padding: 10px;
  }
  .question-bank h2 {
    font-size: 24px;
    margin: 15px 0;
    text-align: center;
  }
  .qb-cards {
    gap: 15px;
  }
  .qb-card {
    width: 200px;
    height: 300px;
    padding: 8px;
  }
  .qb-card img {
    width: 160px;
    height: 140px;
  }
  .qbc-head {
    font-size: 20px;
  }
  .qbc-des {
    font-size: 14px;
    margin: 8px;
  }
  .view-btn {
    width: 120px;
    padding: 4px;
    font-size: 14px;
  }
}
@media screen and (max-width: 480px) {
  .q-hero {
    height: 30vh;
    padding: 20px;
  }
  .q-hero h1 {
    font-size: 28px;
    margin-top: 60px;
  }
  .q-hero button {
    width: 160px;
    padding: 6px 12px;
    font-size: 14px;
  }
  .question-bank h2 {
    font-size: 20px;
  }
  .qb-card {
    width: 260px;
    height: 280px;
  }
  .qb-card img {
    width: 140px;
    height: 120px;
  }
  .qbc-head {
    font-size: 18px;
  }
  .qbc-des {
    font-size: 12px;
    margin: 5px;
  }
  .view-btn {
    width: 80%;
    padding: 5px;
    font-size: 12px;
  }
}
/*# sourceMappingURL=question-bank.component.css.map */
